import React, { FC, useMemo } from "react";
import { OrderEventSaleStatus, OrderStatus } from "interfaces/front/business";
import styled, { css } from "styled-components";

const StatusChip: FC<{ status: OrderStatus, orderEventSaleStatus?: OrderEventSaleStatus | null }> = ({ status, orderEventSaleStatus }) => {
  const statusLabel = useMemo(() =>{
    const base = STATUS_LABELS[status] ?? "不明";
    if (status !== "completed" || !orderEventSaleStatus) return base;
    const suffix = orderEventSaleStatus === "picked_up" ? "（受取済）" : "（未受取）";
    return `${base}${suffix}`;
  }, [status, orderEventSaleStatus]);

  return <Root $status={status}>{statusLabel}</Root>;
};
export default StatusChip;

const STATUS_LABELS: Record<OrderStatus, string> = { completed: "入金済み", requested: "未入金", canceled: "キャンセル済み" };

const Root = styled.div<{ $status: OrderStatus }>`
  padding: 10px;
  text-align: center;
  margin-bottom: 20px;
  border-radius: 5px;
  ${({ $status }) => {
    switch ($status) {
      case "completed":
        return css`
          border: solid 1px #4db700;
          background-color: #eafddf;
          color: #4db700;
        `;
      case "requested":
        return css`
          border: solid 1px #e9af00;
          background-color: #fdf8df;
          color: #e9af00;
        `;
      case "canceled":
        return css`
          border: solid 1px #f00;
          background-color: #fee;
          color: #f00;
        `;
    }
  }}
`;
